// import { io } from "socket.io-client";
import socketIOClient from "socket.io-client";

export const socket = socketIOClient(
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_URL_API
    : "http://localhost:1337",
  {
    withCredentials: true,
    extraHeaders: {
      "my-custom-header": "abcd",
    },
    transports: ["websocket", "polling", "flashsocket"],
  }
);
